import { render, staticRenderFns } from "./ModalAccountEdit.vue?vue&type=template&id=2b26de02&"
import script from "./ModalAccountEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalAccountEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports